"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSprite = createSprite;
exports.createElement = createElement;
exports["default"] = exports.makePixiApi = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function createContainer() {
  return new PIXI.Container();
}

function createSprite(texture) {
  return new PIXI.Sprite(texture);
}

function createElement(tag, texture, data) {
  switch (tag) {
    case 'sprite':
      return createSprite(texture);

    case 'container':
      return createContainer();

    default:
      throw new Error('Unknown Pixi element tag ' + tag);
  }
}

function parentNode(child) {
  return child.parent;
}

function removeChild(node, child) {
  node.removeChild(child);
}

function addChild(node, child) {
  node.addChild(child);
}

function addChildBefore(node, child, before) {
  if (before) {
    before = node.children.indexOf(before);
    node.addChildAt(child, before);
  } else {
    node.addChild(child);
  }
}

function setDataContent(elm, data) {
  elm.x = data.x || 0;
  elm.y = data.y || 0;
  if (data.width) elm.width = data.width;
  if (data.height) elm.height = data.height;
  if (data.scale) elm.scale.set(data.scale.x, data.scale.y);
  if (data.alpha) elm.alpha = data.alpha;
  if (data.anchor) elm.anchor = data.anchor;
  if (elm.setData) elm.setData(data);
}

var makePixiApi = function makePixiApi(createElement) {
  return {
    createElement: createElement,
    parentNode: parentNode,
    addChild: addChild,
    addChildBefore: addChildBefore,
    removeChild: removeChild,
    setDataContent: setDataContent
  };
};

exports.makePixiApi = makePixiApi;

var _default = makePixiApi(createElement);

exports["default"] = _default;